exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activities-server-table thead tr th {\n  width: 16%;\n}\n.activities-server-table thead tr th:first-child {\n  width: 13%;\n}\n.activities-server-table thead tr th:nth-child(5) {\n  width: auto;\n}\n.activities-server-table thead tr th:nth-child(6) {\n  width: 50%;\n}\n.activities-server-table thead tr th:last-child {\n  width: 11%;\n}\n.activities-server-table tbody tr td:first-child {\n  text-transform: capitalize;\n}\n.activities-server-table tbody tr td:nth-child(6) {\n  word-break: break-all;\n}\n.activities-server-table tbody tr td:first-letter {\n  text-transform: uppercase;\n}\n", ""]);

// exports
